export default __webpack_public_path__ + "76e10bc7280c09dd81fc1de304a0934d.png";